import React, { Component } from 'react';
import { NutritionSerializer } from 'fitbeat.gym-core';
import { View, ScrollView, StyleSheet, Text, Platform, TouchableOpacity, Dimensions } from 'react-native';
import { Button } from '../../components';
import Accordion from 'react-native-collapsible/Accordion';
import { translate } from 'react-i18next';
import { AccordionShoppingHeader, FormKeyboardSpacer, CheckBoxShoppingList } from '../../ui/components'

import Theme from '../../theme';
import { scaleText, defaultScale } from '../../utils/scaling';
import ServingsCounter from './ServingsCounter';

const width = Dimensions.get('window').width;
const isMobile = width <= 550;

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  // the Map<DayOfWeek, Map<MealOfDay, Meal>> map used in MealPlanWithMeals.mealSchedule
  mealPlans: PlaceholderTypeWhenConvertedToTsx;
  servingCount: number;
}

interface IState {
  servingCountEdit: number;
}

export class ShoppingListEdit extends Component<IProps, IState> {
  constructor(props) {
    super(props);

    const mealsForShoppingList = [];
    const { mealPlans, servingCount, t } = this.props;
    const mealPlansSerialized = NutritionSerializer.serializeMealSchedule(mealPlans);
    const mealPlansClone = JSON.parse(JSON.stringify(mealPlansSerialized));
    const mealPlansCloneDeserialized = NutritionSerializer.deserializeMealSchedule(mealPlansClone);

    this.state = {
      mealPlansEdit: [...mealPlansCloneDeserialized],
      mealsForShoppingList,
      isShoppingListEditModalVisible: false,
      initiallyActiveSection: Platform.OS === 'web' ? 0 : -1,
    };

    this.state.mealPlansEdit.forEach(item => {
      const newItem = item;
      let counter = 0;
      for (var i = 0; i < [...newItem[1]].length; i++) {
        if ([...newItem[1]][i][1].isInShoppingList === true) {
          counter += 1;
        }
      }
      if (counter !== 0) {
        newItem.daySelected = true;
      }
      const day = {
        title: newItem[0],
        content: () => this.shoppingListFields(newItem[1], this.state.mealPlansEdit.indexOf(item)),
        isChecked: newItem.daySelected,
        numberOfMealsSelected: counter,
        isLast: true,
      };
      mealsForShoppingList.push(day);
    });
    this.state.servingCountEdit = servingCount;
  }

  public toggleIsInShoppingList(mealPlanIndex, mealOfDayIndex) {
    const mealPlan = this.state.mealPlansEdit;
    [...mealPlan[mealPlanIndex][1]][mealOfDayIndex][1].isInShoppingList = ![...mealPlan[mealPlanIndex][1]][mealOfDayIndex][1].isInShoppingList;
    this.state.mealsForShoppingList.forEach(item => {
      if ((item.title === mealPlan[mealPlanIndex][0]) && ([...mealPlan[mealPlanIndex][1]][mealOfDayIndex][1].isInShoppingList === false)) {
        item.isChecked = false;
      }
      let counter = 0;
      for (var i = 0; i < [...mealPlan[this.state.mealsForShoppingList.indexOf(item)][1]].length; i++) {
        if ([...mealPlan[this.state.mealsForShoppingList.indexOf(item)][1]][i][1].isInShoppingList === true) {
          counter += 1;
        }
      }
      item.numberOfMealsSelected = counter;
      if (counter !== 0) {
        item.isChecked = true;
      }
    })
    this.setState({ meal: mealPlan ,mealsForShoppingList: this.state.mealsForShoppingList});
  }

  public toggleDaySelection(indexOfDay) {
    const mealSelectionOnIndexDay = this.state.mealsForShoppingList[indexOfDay];
    mealSelectionOnIndexDay.isChecked = !mealSelectionOnIndexDay.isChecked;
    const mealPlanForAllDays = this.state.mealPlansEdit;
    const mealsForIndexDay = mealPlanForAllDays[indexOfDay];
    const indexOfDataInMealsForDay = 1;
    const dataInMealsForDay = mealsForIndexDay[indexOfDataInMealsForDay];

    dataInMealsForDay.forEach(meal => {
      meal.isInShoppingList = mealSelectionOnIndexDay.isChecked;
    })
    let counter = 0;
    for (var dayIterator = 0; dayIterator < [...dataInMealsForDay].length; dayIterator++) {
      if ([...dataInMealsForDay][dayIterator][1].isInShoppingList === true) {
        counter += 1;
      }
      mealSelectionOnIndexDay.numberOfMealsSelected = counter;
    }
    this.setState({ meal: mealPlanForAllDays, mealsForShoppingList: this.state.mealsForShoppingList });
  }

  public shoppingListFields = (details, index) => {
    const mealList = [...details];
    const { t } = this.props;

    return (
      <View>
        {mealList.map(item =>
        <TouchableOpacity onPress={() => this.toggleIsInShoppingList(index, mealList.indexOf(item))}>
          <View style={styles.accordionContent} key={mealList.indexOf(item)}>
            <View style={styles.optionInfoContainer}>
              <CheckBoxShoppingList
                size={20}
                onPress={() => this.toggleIsInShoppingList(index, mealList.indexOf(item))}
                isActive={item[1].isInShoppingList}
              />
              <Text style={styles.serviceTextContainer}>
                <Text style={styles.name}>
                  {t(item[0])}
                </Text>
              </Text>
            </View>
            <View style={styles.mealItemContainer}>
              <Text style={styles.description}>
                {item[1].displayName}
              </Text>
            </View>
          </View>
        </TouchableOpacity>
        )}
      </View>
    );
  }

  public renderHeader = (section, index, isActive) => (
    <AccordionShoppingHeader
      index={index}
      section={section}
      isActive={isActive}
      setActiveIndex={this.setActiveIndex}
      onPress={this.clearSubmitForm}
      isChecked={section.isChecked}
      toggleSelection={() => this.toggleDaySelection(index)}
      numberOfMealsSelected={section.numberOfMealsSelected}
    />
  );

  public renderContent = section => (
    <View style={styles.content}>
      {section.content()}
    </View>
  );

  public setActiveIndex = (value) => {
    this.setState({ activeSection: value });
  }

  public saveShoppingList = () => {
    const { updateMealPlan, closeModal } = this.props;
    const { mealPlansEdit, servingCountEdit } = this.state;
    updateMealPlan(mealPlansEdit, servingCountEdit);
    closeModal();
  }

  public updateServingCount = (newServingCount) => {
    this.setState({ servingCountEdit: newServingCount });
  };

  public render() {
    const { initiallyActiveSection, isDaySelected, isLoading } = this.state;
    const { t } = this.props;
    const { servingCountEdit } = this.state;

    return (
      <View style={styles.container}>
        <FormKeyboardSpacer>
          <ScrollView keyboardShouldPersistTaps="handled">
            {isMobile && <View style={styles.thinTopDivider} />}
            <ServingsCounter
              servings={servingCountEdit}
              onChanged={this.updateServingCount}
              t={t}
            />
            <View style={styles.thinBottomDivider} />

            <View>
              <Accordion
                sections={this.state.mealsForShoppingList}
                renderHeader={this.renderHeader}
                renderContent={this.renderContent}
                touchableComponent={TouchableOpacity}
                activeSection={this.state.activeSection}
                initiallyActiveSection={initiallyActiveSection}
                collapsedHeight={defaultScale(1.1)}
              />
            </View>
          </ScrollView>
          <View style={styles.footer}>
            <Button
              fontColor={Theme.WHITE}
              title={t('saveShoppingList')}
              onPress={this.saveShoppingList}
              overrideFontStyles={{...Theme.textStyle.bodyCopyBold, color: Theme.WHITE}}
            />
          </View>
        </FormKeyboardSpacer>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    marginLeft: -15,
    marginRight: -15,
  },
  buttonContainer: {
    alignContent: 'center',
    justifyContent: 'center',
  },
  mealCountContainer: {
    width: '60%'
  },
  optionInfoContainer: {
    flex: 1,
    paddingHorizontal: defaultScale(10),
    flexDirection: 'row',
  },
  name: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.CHARCOAL,
  },
  thinTopDivider: {
    marginTop: defaultScale(11),
    padding: 1, // padding makes the border more visible
    borderTopWidth: 0.5,
    borderTopColor: Theme.GREY_MEDIUM_LIGHT,
  },
  thinBottomDivider: {
    marginTop: defaultScale(6),
    marginBottom: defaultScale(7),
    padding: 1, // padding makes the border more visible
    borderBottomWidth: 0.5,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
  mealItemContainer: {
    borderBottomWidth: 0.5,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
    marginRight: '10%',
    marginLeft: '2%',
  },
  description: {
    ...Theme.textStyle.small,
    fontSize: scaleText(14),
    color: Theme.GREY_MEDIUM,
    marginLeft: isMobile ? '10%' : '6%',
    paddingBottom: defaultScale(5),
  },
  disabledName: {
    color: Theme.GREY,
    fontFamily: Theme.CustomNormalItalic,
  },
  serviceTextContainer: {
    flex: 1,
    fontSize: 14,
    lineHeight: 30,
    textAlign: 'left',
    color: Theme.GREY_DARK,
  },
  accordionContent: {
    paddingBottom: defaultScale(10),
    paddingTop: defaultScale(10),
    paddingLeft: defaultScale(15),
    backgroundColor: Theme.GREY_LIGHT,
  },
  checkBox: {
    fontFamily: Theme.Custom800,
    fontSize: 13,
    fontWeight: "bold",
  },
  footer: {
    flex: 1,
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
    marginTop: defaultScale(30),
    marginLeft: defaultScale(8),
    marginRight: defaultScale(8),
  },
  saveBtn: {
    backgroundColor: Theme.PRIMARY,
  },
  checkBoxWhole: {
    marginTop: defaultScale(5),
  }
});

export default translate(['nutrition'], { wait: true })(ShoppingListEdit);
